import { render, staticRenderFns } from "./Data2.vue?vue&type=template&id=0a46b4b6&"
import script from "./Data2.vue?vue&type=script&lang=js&"
export * from "./Data2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports